// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  CLIENTES_HANDLE_ON_CHANGE_CLIENTE,
} from './constants';

export function handleOnChangeCliente( args = {} ) {
  return (dispatch, getState) => {
    const { clientes } = getState()
    const { name, value } = args

    let clientObject = clientes.selectedClient ? clientes.selectedClient : {}

    clientObject[name] = value

    dispatch ({
      type: CLIENTES_HANDLE_ON_CHANGE_CLIENTE,
      data: clientObject
    });
  }
  
}

export function reducer(state, action) {
  switch (action.type) {
    case CLIENTES_HANDLE_ON_CHANGE_CLIENTE:
      return {
        ...state,
        selectedClient: action.data,
      };

    default:
      return state;
  }
}
